module.exports = __webpack_public_path__ + "static/media/self-bill.ec0cb473.svg";